export enum ExtractedBillingFrequencyMonths {
  ONE = '1',
  SIX = '6',
  TWELVE = '12',
}
